import _ from 'lodash';
import { client } from '../http';

export default {
  async createBenefit(promotion) {
    const response = await client.post('/api/benefits', { promotion });
    return response.data;
  },

  async createBenefitByPromoCode(promoCode) {
    const response = await client.post('/api/partial-auth/benefits/promo-code', { promoCode });
    return response.data;
  },

  async getEligibleBenefits() {
    const response = await client.get('/api/benefits/eligible');
    return response.data;
  },

  async getBestBenefitFromEligibleBenefits() {
    const response = await client.get('/api/benefits/eligible');
    return _.maxBy(response.data, 'benefitAmount');
  },

  async redeemBenefit(benefitId) {
    const response = await client.put(`/api/benefits/redeem/${benefitId}`);
    return response.data;
  },
};
